<div class="registration-provider-oauth">
  <h5>{{ 'fgbcl.registration.provider.oath.title' | translate }}</h5>

  <ng-container *ngIf="!customer.ExternalRefNumber">
    <p [innerHtml]="'fgbcl.registration.provider.oath.instruction' | translate | markdownTranslate"></p>
    <div id="provider-login" #providerLogin></div>
  </ng-container>

  <fgbcl-errors></fgbcl-errors>

  <ng-container *ngIf="customer.ExternalRefNumber">
    <div class="account-info-container">
      <span class="account-created-label">{{
        'fgbcl.registration.provider.oauth.account.created.label' | translate : { fgbdefault: 'Account Created' }
      }}</span>
      <span class="account-number"
        >{{ 'fgbcl.registration.provider.oauth.account.number.text' | translate : { fgbdefault: 'Account Number' } }}:
        {{ customer.ExternalRefNumber }}</span
      >
    </div>
  </ng-container>

  <div class="navigation-wrapper">
    <fgbcl-registration-navigation
      (nextButtonClicked)="submitStep()"
      [stepType]="stepType"
      [hideNextBtn]="!customer.ExternalRefNumber"
    >
    </fgbcl-registration-navigation>
  </div>
</div>
